<!-- Step: HEALTH SYSTEM DETAILS -->
<div id="step-health-system-details">
  <div>
    <!-- Health System Brand Card -->
    <div>
      <div class="mt-2">
        <div
          class="brand-logo-banner"
          [class.brand-logo-banner--initials]="
            !shouldShowBrandLogo((configService.searchConfigSubject | async)?.selectedBrand?.id)
          "
        >
          <img
            *ngIf="
              shouldShowBrandLogo(
                (configService.searchConfigSubject | async)?.selectedBrand?.id
              );
              else brandInitials
            "
            class="brand-logo"
            src="https://cdn.fastenhealth.com/logos/sources/{{
              (configService.searchConfigSubject | async)?.selectedBrand?.id
            }}.png"
            alt=""
            (error)="handleBrandLogoError()"
          />
          <ng-template #brandInitials>
            <span class="brand-banner-initials">
              {{ getBrandInitials((configService.searchConfigSubject | async)?.selectedBrand?.name || '') | uppercase }}
            </span>
          </ng-template>
        </div>
        <h2 id="hsd-name" class="fdk-type-heading-2 text-fdk-primary mt-fdk-xs">
          {{ (configService.searchConfigSubject | async)?.selectedBrand?.name }}
        </h2>
      </div>
      <div
        *ngIf="
          (configService.searchConfigSubject | async)?.selectedBrand?.locations
        "
        class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs flex items-center gap-fdk-xxxs"
      >
        <fdk-icon name="location-off" [size]="24" />
        <span id="hsd-location" class="text-base">
          <span
            class="comma"
            *ngFor="
              let stateCode of (configService.searchConfigSubject | async)
                ?.selectedBrand?.locations || [] | slice: 0 : 3
            "
            >{{ stateCode | stateName }}</span
          >
          <span
            class="comma"
            *ngIf="
              (
                (configService.searchConfigSubject | async)?.selectedBrand
                  ?.locations || []
              ).length > 4
            "
            >+
            {{
              (
                (configService.searchConfigSubject | async)?.selectedBrand
                  ?.locations || []
              ).length
            }}</span
          >
        </span>
      </div>

      <div
        *ngIf="
          (configService.searchConfigSubject | async)?.selectedBrand
            ?.brand_website
        "
        class="fdk-type-paragraph text-fdk-accent mt-fdk-xxxs"
        id="hsd-website-container"
      >
        <fdk-link
          id="hsd-website"
          [href]="
            (configService.searchConfigSubject | async)?.selectedBrand
              ?.brand_website ?? ''
          "
          target="_blank"
          rel="noopener noreferrer"
          >{{
            (configService.searchConfigSubject | async)?.selectedBrand
              ?.brand_website
          }}</fdk-link
        >
      </div>
    </div>



    <p class="mt-fdk-m fdk-type-paragraph text-fdk-secondary">
      Where were you treated? Choose a provider to connect your health records.
    </p>

    <!-- Institutions List -->
    <div class="flex flex-col gap-fdk-xxs mt-fdk-s" id="hsd-institutions-list">
      <ng-container
        *ngFor="
          let portal of (configService.searchConfigSubject | async)
            ?.selectedBrand?.portals
        "
      >
        <fdk-card
          *ngFor="let endpoint of portal.endpoints"
          class="institution-card"
          [title]="portal.name"
          [description]="portal.description ?? ''"
          variant="add"
          (click)="
            addPendingAccount(
              configService.searchConfig$?.selectedBrand!,
              portal,
              endpoint
            )
          "
        />
      </ng-container>
    </div>
  </div>
</div>
<!-- End Step: HEALTH SYSTEM DETAILS -->
